export class LkpStoresModel{
  strcode = '' ;
  strdesc1 = '' ;
  strdesc2 = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2022-01-01' ;

}
